import {get} from '../../Utils/axios'
const procedure = {
    namespaced: true,
    state: () => ({
        procedureData: {} ,//保存饲喂程序数据,在饲喂程序列表中选中的数据
        procedureDetail: {} ,//保存饲喂程序数据，根据饲喂程序id查询到的详情
        gestationDay:114 ,//保存妊娠天数
        // lactationLength:21 //保存哺乳天数
    }),
    mutations: {
        setProcedureData(state, action) {
            state.procedureData = action;
            // console.log(state,"饲喂程序详情")
        },
        setProcedureDetail(state, action) {
            state.procedureDetail = action;
            console.log(state.procedureDetail,"state.procedureDetail")
        },
        setGestationDay(state,action){
            state.gestationDay=Number(action);
            // console.log(state.gestationDay,"妊娠天数")
        },
        // setLactationLength(state,action){
        //     state.lactationLength=Number(action);

        //     console.log(state.lactationLength,"哺乳天数")
        // }
    },
    actions: {
        //根据id查询饲喂程序详情
        async getProcedureDetail(context, payload) {
            let res = await get(
                "/sat-maximization/pigFeedingProgramInfo/pigFeedingProgramInfoById?id=" +
                payload.id
            );
            let { success, data } = res
            if (success) {
                context.commit('setProcedureDetail',data)
            }
        },
    }
}

export default procedure